import { render, staticRenderFns } from "./Notification.vue?vue&type=template&id=de70e6fe&scoped=true&"
import script from "./Notification.vue?vue&type=script&lang=js&"
export * from "./Notification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de70e6fe",
  null
  
)

component.options.__file = "Notification.vue"
export default component.exports